export interface ImageSize {
  readonly id: 'small' | 'medium' | 'large'
  readonly label: string
  readonly scale: number
}

export const IMAGE_SIZES: readonly ImageSize[] = [
  { id: 'small', label: 'Small', scale: 0.35 },
  { id: 'medium', label: 'Medium', scale: 0.6 },
  { id: 'large', label: 'Large', scale: 0.9 },
] as const

export const DEFAULT_IMAGE_SIZE: ImageSize = IMAGE_SIZES[1]
